<template>
  <div>
    <div class="head-box">
      <h4>中间号使用统计</h4>
      <div class="c-flex">
        <el-date-picker
          v-model="searchDate"
          type="datetimerange"
          start-placeholder="默认查询本周"
          end-placeholder="默认查询本周"
          :default-time="['00:00:00', '23:59:59']"
          value-format="yyyy-MM-dd HH:mm:ss"
          @change="
            fpi.page = 1;
            getData();
          "
          class="search-date"
        ></el-date-picker>
      </div>
    </div>
    <div class="content-box">
      <div class="content-table">
        <el-table ref="table" height="100%" :data="fpi.data" highlight-current-row>
          <el-table-column
            prop="cityCode"
            label="城市"
            :formatter="osg.formatCityCode"
          ></el-table-column>
          <el-table-column prop="cityCode" label="区号"></el-table-column>
          <el-table-column prop="currentCount" label="本地区号接打次数"></el-table-column>
          <el-table-column prop="otherCount" label="外地区号接打次数"></el-table-column>
          <el-table-column label="中间号：本地使用次数/外地使用次数">
            <template slot-scope="scope">
              <tr v-for="(val, key, i) in scope.row.usageCount" :key="i">
                <td style="border-bottom:none;padding:0;">{{ key }}：</td>
                <td style="border-bottom:none;padding:0;">{{ val }}</td>
              </tr>
            </template>
          </el-table-column>
        </el-table>
        <!-- <el-pagination
          class="pagination"
          @size-change="pageSizeChange"
          @current-change="pageChange"
          :current-page="fpi.page"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="fpi.rows"
          layout="total, sizes, prev, pager, next, jumper"
          :total="fpi.total"
        ></el-pagination> -->
      </div>
    </div>
  </div>
</template>
<script>
export default {
  activated() {
    window.$this = this;
  },
  name: 'PrivateNumberRecord',
  data() {
    window.$this = this;
    return {
      name: 'privateNumberRecord',
      fpi: {},
      searchDate: [],
      openDetail: false,
      formData: {
        exts: {}
      },
      options: {}
    };
  },
  mounted() {
    this.doInit();
    this.osg.codeoption(() => {
      this.getData();
    });
  },
  methods: {
    pageSizeChange(pageSize) {
      this.fpi.rows = pageSize;
      this.getData();
    },
    pageChange(currentPage) {
      this.fpi.page = currentPage;
      this.getData();
    },
    doInit() {
      this.openDetail = false;
      this.formData = { exts: {} };
    },
    getData() {
      this.searchDate = this.searchDate || [];
      let params = {
        startTime: this.searchDate[0],
        endTime: this.searchDate[1]
      };
      this.osg.ajax('/basic/winnerlook/getUsableMiddleNumberContent.do', params, res => {
        this.fpi = res;
        // 兼容safari浏览器表格
        this.$nextTick(() => {
          this.$refs.table.doLayout();
          this.$forceUpdate();
        });
      });
    }
  }
};
</script>
